import { getAuthenticatedInstance } from './helpers/axios.helpers';

const authenticatedInstance = getAuthenticatedInstance();

export async function getNews(): Promise<any> {
  return authenticatedInstance.get('/news');
}
